let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eXuP8")).then(() => parcelRequire('6At3v'));